import { createBridgeClient, type Bridge } from '@casa/bridge';
import { withPageWakeLock } from './page_wake_lock.ts';
import { serverTransport, type BrowserPage } from './server_transport.ts';
import { detectTransport } from './transport.ts';

// The bridge of the hosting shell, or, in a browser (no shell announced itself), of the companion
// server that served the page.
const globals = globalThis as unknown as Record<string, unknown>;
const transport = globals.casaHost === undefined ? serverTransport(globals as unknown as BrowserPage) : detectTransport(globals);

const client = transport ? createBridgeClient(transport, { log: (message) => console.warn(message) }) : null;

/**
 * The bridge; null when the page runs where there is none (a page opened from a file, say). In a
 * browser, the page keeps the screen on itself.
 */
export const bridge: Bridge | null = client && globals.casaHost === undefined ? withPageWakeLock(client, globalThis as unknown as Parameters<typeof withPageWakeLock>[1]) : client;
